module.exports = __webpack_public_path__ + "img/products-active.72bb7b63.svg";